import { Icon, Row, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { keepState } from './../../../actions/appAction';
import { changeShipmentDetail, getDetailShipment, resetStateShipmentDetail } from './../../../actions/detailShipment';
import history from './../../../services/history';
import OrderInformation from './components/order-information';
import Packages from './components/packages';
import ShipTo from './components/ship-to';
import ShipmentOptions from './components/shipment-options';
import ShipmentRemark from './components/shipment-remark';
import Utility from './components/utility';
import './styles.css';
import { titleHead } from './../../../services/helper'
import { FulfillOption as FulfillOptionConst } from './../../../constants';
import Storage from '../../../services/Storage';
import { shipperInfor } from '../../../actions/shipperInfor';

class DetailShipment extends Component {
    constructor(props) {
        super(props)
        let { fulfillment_option, Summary }  = this.props;
        let FulfillmentFlg = parseInt(Storage.get('FulfillmentFlg'))
        let link = '/shipments';

        if (FulfillmentFlg) {
            if (fulfillment_option === FulfillOptionConst.YAMATO.CODE) {
                link = '/shipments/yamato'
            } else {
                link = '/shipments/in-house'
            }
        }

        this.state = {
            link
        }
    }
    componentDidMount() {
        titleHead('Shipment Detail')

        this.props.getDetailShipment(this.getPackageId())
        this.props.changeShipmentDetail({ value: true, column: 'isLoading' })
        this.props.resetStateShipmentDetail()
        this.props.shipperInfor()
    }

    getPackageId = () => {
        let url = window.location.href
        let package_id = url.split('package_id=')[1]

        return package_id;
    }

    render() {
        let _this = this;
        return (
            <Spin spinning={this.props.detailShipment.isLoading} tip='Loading'>
                <div id="add-order" className='detail-shipment'>
                    <div className="edit-title">Shipment Detail</div>
                    <Icon className='close-order-animation'
                        onClick={() => {
                            history.push(this.state.link)
                            this.props.keepState(true)
                        }}
                        type="close" theme="outlined" />
                    <Row className='content-add-order'>
                        <OrderInformation />
                        <Row gutter={8} className='ship-to-shipment-option'>
                            <ShipTo />
                            <ShipmentOptions />
                        </Row>
                        <Row className='shipment-remark'>
                            <ShipmentRemark />
                        </Row>
                        <Packages />
                    </Row>
                    <Utility link={this.state.link}/>
                </div>
            </Spin>
        );
    }
}

const mapStateToProps = state => {
    return {
        detailShipment: state.detailShipment,
        information: state.addOrder.information,
        shipperInformation: state.detailShipment.shipperInformation,
        fulfillment_option: state.shipmentReducer.fulfillment_option,
        Summary: state.headerReducer.Summary
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDetailShipment: payload => {
            dispatch(getDetailShipment(payload))
        },
        changeShipmentDetail: payload => {
            dispatch(changeShipmentDetail(payload))
        },
        keepState: payload => {
            dispatch(keepState(payload))
        },
        shipperInfor: payload => {
            dispatch(shipperInfor(payload))
        },
        resetStateShipmentDetail: payload => {
            dispatch(resetStateShipmentDetail(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DetailShipment)




// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/index.js